import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

const NEON_CYAN = "#00f2ff";
const NEON_RED = "#ff003c";
const NEON_GREEN = "#39ff14";

function AdminCertificationPage() {
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const rejectionReasons = [
    "Identité invalide",
    "Documents insuffisants",
    "Informations incomplètes"
  ];

  const loadRequests = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API}/admin/verifications`);
      const data = await res.json();

      if (data.success) {
        const pendingRequests = (data.requests || []).filter(
          (request) => request.status === "pending"
        );

        setRequests(pendingRequests);
      } else {
        alert(data.message || "Impossible de charger les demandes.");
      }
    } catch (error) {
      console.log(error);
      alert("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const formatDate = (dateValue) => {
    if (!dateValue) return "Date inconnue";

    try {
      return new Date(dateValue).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    } catch (e) {
      return String(dateValue);
    }
  };

  const getAvatarUrl = (avatar) => {
    if (!avatar) {
      return "https://via.placeholder.com/80";
    }

    if (String(avatar).startsWith("http")) {
      return avatar;
    }

    return `https://live-evo.com/uploads/${avatar}`;
  };

  const openDocument = (url) => {
    if (!url) {
      alert("Aucun document disponible.");
      return;
    }

    const finalUrl = String(url).startsWith("http")
      ? url
      : `https://live-evo.com/${String(url).replace(/^\/+/, "")}`;

    window.open(finalUrl, "_blank");
  };

  const acceptRequest = async () => {
    if (!selectedRequest?.id) return;

    try {
      const res = await fetch(
        `${API}/admin/verifications/${selectedRequest.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status: "approved",
            admin_email: "admin@live-evo.com"
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        alert("Certification acceptée.");
        setSelectedRequest(null);
        loadRequests();
      } else {
        alert(data.message || "Validation impossible.");
      }
    } catch (error) {
      alert("Impossible de contacter le serveur.");
    }
  };

  const rejectRequest = async (reason) => {
    if (!selectedRequest?.id) return;

    try {
      const res = await fetch(
        `${API}/admin/verifications/${selectedRequest.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            status: "rejected",
            reason,
            admin_email: "admin@live-evo.com"
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        alert("Demande refusée.");
        setSelectedRequest(null);
        loadRequests();
      } else {
        alert(data.message || "Refus impossible.");
      }
    } catch (error) {
      alert("Impossible de contacter le serveur.");
    }
  };

  return (
    <div
      style={{
        background: "#000",
        minHeight: "100vh",
        color: "#fff"
      }}
    >
      <div
        style={{
          padding: "25px 20px",
          background: "#050505",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <div
          style={{
            color: "#fff",
            fontWeight: "bold"
          }}
        >
          🛡️ Certifications
        </div>

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "transparent",
            border: "none",
            color: NEON_CYAN,
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Quitter
        </button>
      </div>

      <div style={{ padding: 15 }}>
        {!selectedRequest ? (
          <>
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 50,
                  color: NEON_CYAN
                }}
              >
                Chargement...
              </div>
            ) : requests.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 50
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 18,
                    marginBottom: 8
                  }}
                >
                  Aucune demande en attente
                </div>

                <div style={{ color: "#777" }}>
                  Les demandes acceptées ou refusées disparaissent automatiquement.
                </div>
              </div>
            ) : (
              requests.map((item) => (
                <div
                  key={item.id}
                  onClick={() => setSelectedRequest(item)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#0a0a0a",
                    padding: 15,
                    borderRadius: 10,
                    marginBottom: 10,
                    border: "1px solid rgba(0,242,255,0.12)",
                    cursor: "pointer"
                  }}
                >
                  <img
                    src={getAvatarUrl(item.avatar)}
                    alt=""
                    style={{
                      width: 45,
                      height: 45,
                      borderRadius: "50%",
                      marginRight: 15,
                      objectFit: "cover",
                      background: "#111"
                    }}
                  />

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        color: NEON_GREEN,
                        fontSize: 11,
                        fontWeight: "bold",
                        marginBottom: 4
                      }}
                    >
                      Demande #{item.id}
                    </div>

                    <div
                      style={{
                        color: "#fff",
                        fontWeight: "bold"
                      }}
                    >
                      {item.pseudo ||
                        item.public_name ||
                        item.user_email}
                    </div>

                    <div
                      style={{
                        color: "#666",
                        fontSize: 11,
                        marginTop: 2
                      }}
                    >
                      Catégorie : {item.category || "Non renseignée"}
                    </div>

                    <div
                      style={{
                        color: "#666",
                        fontSize: 11,
                        marginTop: 2
                      }}
                    >
                      Reçu le : {formatDate(item.created_at)}
                    </div>

                    <div
                      style={{
                        color: NEON_CYAN,
                        fontSize: 11,
                        marginTop: 4
                      }}
                    >
                      Statut : {item.status || "pending"}
                    </div>
                  </div>

                  <div style={{ color: NEON_CYAN }}>
                    Détails →
                  </div>
                </div>
              ))
            )}
          </>
        ) : (
          <div style={{ maxWidth: 1000 }}>
            <button
              onClick={() => setSelectedRequest(null)}
              style={{
                background: "transparent",
                border: "none",
                color: "#888",
                marginBottom: 20,
                cursor: "pointer"
              }}
            >
              ← Retour liste
            </button>

            <div
              style={{
                color: NEON_GREEN,
                fontSize: 15,
                fontWeight: "bold",
                marginBottom: 15
              }}
            >
              Demande de certification #{selectedRequest.id}
            </div>

            <Section
              title="👤 Infos demandeur"
              content={[
                `Pseudo : ${selectedRequest.pseudo || "Non renseigné"}`,
                `Email : ${selectedRequest.user_email || "Non renseigné"}`,
                `Nom public : ${selectedRequest.public_name || "Non renseigné"}`,
                `Nom complet : ${selectedRequest.full_name || "Non renseigné"}`,
                `Pays : ${selectedRequest.country || "Non renseigné"}`,
                `Téléphone : ${selectedRequest.phone || "Non renseigné"}`,
                `Catégorie : ${selectedRequest.category || "Non renseignée"}`,
                `Statut : ${selectedRequest.status || "pending"}`
              ]}
            />

            <Section
              title="🔗 Liens"
              content={[
                `Réseau social : ${selectedRequest.social_link || "Non renseigné"}`,
                `Site web : ${selectedRequest.website || "Non renseigné"}`,
                `Presse : ${selectedRequest.press_link || "Non renseigné"}`
              ]}
            />

            <Section
              title="🏢 Organisation"
              content={[
                `Société : ${selectedRequest.company_name || "Non renseigné"}`,
                `SIRET / numéro : ${selectedRequest.registration_number || "Non renseigné"}`,
                `Email pro : ${selectedRequest.business_email || "Non renseigné"}`,
                `Rôle : ${selectedRequest.role_in_organization || "Non renseigné"}`
              ]}
            />

            <Section
              title="📝 Raison"
              content={[
                selectedRequest.reason ||
                  "Aucune raison renseignée"
              ]}
            />

            <div style={sectionTitle}>
              📄 Documents
            </div>

            <DocButton
              text="Ouvrir document identité"
              onClick={() =>
                openDocument(
                  selectedRequest.identity_document_url
                )
              }
            />

            <DocButton
              text="Ouvrir justificatif"
              onClick={() =>
                openDocument(
                  selectedRequest.proof_document_url
                )
              }
            />

            <DocButton
              text="Ouvrir document supplémentaire"
              onClick={() =>
                openDocument(
                  selectedRequest.extra_document_url
                )
              }
            />

            <div
              style={{
                marginTop: 30,
                paddingBottom: 40
              }}
            >
              <button
                onClick={acceptRequest}
                style={{
                  width: "100%",
                  padding: 15,
                  borderRadius: 8,
                  border: "none",
                  background: NEON_GREEN,
                  color: "#000",
                  fontWeight: "bold",
                  marginBottom: 20,
                  cursor: "pointer"
                }}
              >
                ✅ ACCEPTER
              </button>

              <div style={sectionTitle}>
                ❌ REFUSER :
              </div>

              {rejectionReasons.map((reason) => (
                <button
                  key={reason}
                  onClick={() => rejectRequest(reason)}
                  style={{
                    width: "100%",
                    padding: 10,
                    background: "#111",
                    borderRadius: 6,
                    border: "none",
                    marginBottom: 5,
                    color: NEON_RED,
                    fontSize: 12,
                    cursor: "pointer"
                  }}
                >
                  {reason}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Section({ title, content }) {
  return (
    <>
      <div
        style={{
          color: NEON_CYAN,
          fontSize: 12,
          fontWeight: "bold",
          marginTop: 20,
          marginBottom: 10
        }}
      >
        {title}
      </div>

      <div
        style={{
          background: "#0a0a0a",
          padding: 15,
          borderRadius: 10,
          border: "1px solid rgba(0,242,255,0.12)"
        }}
      >
        {content.map((line, index) => (
          <div
            key={index}
            style={{
              color: "#fff",
              fontSize: 13,
              marginBottom: 8
            }}
          >
            {line}
          </div>
        ))}
      </div>
    </>
  );
}

function DocButton({ text, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        background: "#111",
        padding: 14,
        borderRadius: 8,
        marginBottom: 8,
        border: "1px solid rgba(0,242,255,0.18)",
        color: NEON_CYAN,
        fontWeight: "bold",
        cursor: "pointer"
      }}
    >
      {text}
    </button>
  );
}

const sectionTitle = {
  color: NEON_CYAN,
  fontSize: 12,
  fontWeight: "bold",
  marginTop: 20,
  marginBottom: 10
};

export default AdminCertificationPage;
